import { Component } from '@angular/core';

@Component({
  selector: 'eo-base-table',
  templateUrl: './eo-base-table.component.html',
  styleUrl: './eo-base-table.component.scss'
})
export class EoBaseTableComponent{

}
